import React from 'react';
import { isPast, isSameDay } from 'date-fns';
import styles from '../../Styles/Reservations.module.css';
import IconButton from '../../Images/IconButton';
import WeekTextBox from '../WeekTextBox';
import { labelForHourPadded } from '../../Utils/schema';
import {
  dayKey,
  mobileDayParts,
  isSlotBlockedBy,
} from '../../Utils/ReservationsUtil';

function ReservationsMobileDayView({
  weekLabel,
  prevWeek,
  nextWeek,
  weekDays,
  selectedMobileDay,
  setSelectedMobileDay,
  hours,
  reservationsByDay,
  getSlotConfig,
  activeCalendarId,
  blocks,
  user,
  companyColors,
  onClickSlot,
  companiesInWeek,
  companyNamesById,
}) {
  if (!selectedMobileDay) return null;

  return (
    <div className={styles.mobileWrapper}>
      <div className={styles.mobileWeekHeader}>
        <div style={{ marginRight: '10px' }}>
          <IconButton direction="left" onClick={prevWeek} />
        </div>

        <WeekTextBox text={weekLabel} />

        <div style={{ marginLeft: '10px' }}>
          <IconButton direction="right" onClick={nextWeek} />
        </div>
      </div>

      <div className={styles.mobileDayTabs}>
        {weekDays.map((dateObj, i) => {
          const lbl = mobileDayParts(dateObj);
          const active =
            selectedMobileDay && isSameDay(dateObj, selectedMobileDay);

          return (
            <button
              key={i}
              type="button"
              className={`${styles.mobileDayTab} ${
                active ? styles.mobileDayTabActive : ''
              }`}
              onClick={() => setSelectedMobileDay(dateObj)}
            >
              <span>{lbl.dow}</span>
              <span>{lbl.date}</span>
            </button>
          );
        })}
      </div>

      <div className={styles.mobileSlots}>
        {hours.map((hour, idx) => {
          const key = dayKey(selectedMobileDay);
          const res = reservationsByDay[key]?.[idx];
          const sc = getSlotConfig(activeCalendarId, selectedMobileDay, hour);

          const slotDate = new Date(
            selectedMobileDay.getFullYear(),
            selectedMobileDay.getMonth(),
            selectedMobileDay.getDate(),
            hour,
            0,
            0
          );

          const past = isPast(slotDate);

          const hit = (blocks || [])
            .map((b) => ({ b, r: isSlotBlockedBy(b, selectedMobileDay, hour) }))
            .find((x) => x.r.blocked);

          if (hit) {
            return (
              <div
                key={idx}
                className={`${styles.mobileSlotRow} ${styles.mobileSlotBlocked} ${styles.mobileSlotRowBooked} ${
                  past ? styles.mobileSlotPast : ''
                }`}
              >
                <span className={styles.mobileSlotText}>{hit.r.title}</span>
              </div>
            );
          }

          const canOpen = sc.open && !past && (!res || res.id === user.uid);
          const isBooked = !!res;
          const isMine = !!res && res.id === user.uid;

          let rowClass = styles.mobileSlotUnavailable;
          let text = '';
          let showChevron = false;

          if (isBooked) {
            rowClass = styles.mobileSlotBooked;
            text = `${res.sukunimi || ''}${
              Number(res.hinta || 0) > 0 ? ` (${Number(res.hinta)}€)` : ''
            }`;
          } else if (sc.open && !past) {
            rowClass = styles.mobileSlotBookable;
            showChevron = true;
          } else {
            rowClass = styles.mobileSlotUnavailable;
          }

          if (isMine) {
            rowClass = styles.mobileSlotMyBooking;
          }

          const showTime = !isBooked;
          const layoutClass = isBooked
            ? styles.mobileSlotRowBooked
            : showChevron
              ? styles.mobileSlotRowBookable
              : styles.mobileSlotRowPlain;

          const bgColor =
            isBooked && res?.talonyhtiöid
              ? companyColors[res.talonyhtiöid]
              : undefined;

          const pastClass = past ? styles.mobileSlotPast : '';

          return (
            <div
              key={idx}
              className={`${styles.mobileSlotRow} ${rowClass} ${layoutClass} ${pastClass}`}
              onClick={() => canOpen && onClickSlot(selectedMobileDay, hour)}
              style={{
                cursor: canOpen ? 'pointer' : 'default',
                backgroundColor: bgColor,
              }}
            >
              {isBooked ? (
                <span className={styles.mobileSlotText}>{text}</span>
              ) : showChevron ? (
                <>
                  <span className={styles.mobileSlotTime}>
                    {labelForHourPadded(hour)}
                  </span>
                  <span className={styles.mobileSlotChevron}>›</span>
                </>
              ) : (
                <span className={styles.mobileSlotTime}>
                  {labelForHourPadded(hour)}
                </span>
              )}
            </div>
          );
        })}
      </div>

      {companiesInWeek.length > 0 && (
        <div className={styles.mobileLegendWrapper}>
          <div className={styles.companyLegend}>
            {companiesInWeek.map((companyId) => (
              <div key={companyId} className={styles.legendItem}>
                <span
                  className={styles.legendColor}
                  style={{ backgroundColor: companyColors[companyId] }}
                />
                <span className={styles.legendText}>
                  {companyNamesById?.[companyId] ||
                    user?.companyNames?.[companyId] ||
                    'Taloyhtiö'}
                </span>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}

export default ReservationsMobileDayView;